import React from 'react';
import Backend from '../../../../Layouts/Backend';
import { withTranslation } from 'react-i18next';
import { Button } from '../../../../UI/Common';
import helper from '../../../../../utils/helper';
import Datagrid from '../../../../UI/Datagrid';
import ReactSelect from '../../../../UI/ReactSelect';

const columns = [
  {
    dataField: 'serialNo',
    text: 'Serial Number',
    sort: true,
  },
];
const defaultSorted = [
  {
    dataField: 'serialNo',
    order: 'desc',
  },
];
const AssignAlertsPage = ({ t, ...props }) => {
  const userDept = helper.getUserDepartment();
  const [dept, setDept] = React.useState({
    id: userDept.deptId,
  });
  const [selected, setSelected] = React.useState([]);
  React.useEffect(() => {
    setSelected([]);
    props.onChangeDept(dept.id);
  }, [dept.id]);
  if (Object.keys(props.getGroupError).length) {
    return (
      <Backend>
        <div className="content-inner">
          <h1>{t('This group is unavailable')}</h1>
        </div>
      </Backend>
    );
  }
  const handleOnSelect = (row, isSelect) => {
    if (isSelect) {
      setSelected([...selected, row.id]);
    } else {
      setSelected(selected.filter((x) => x !== row.id));
    }
  };
  const handleOnSelectAll = (isSelect, rows) => {
    const ids = rows.map((r) => r.id);
    if (isSelect) {
      setSelected((selected) => helper.tableHelper.selectAll(selected, ids));
    } else {
      setSelected((selected) => helper.tableHelper.deselectAll(selected, ids));
    }
  };
  const selectRow = {
    mode: 'checkbox',
    clickToSelect: true,
    selected: selected,
    onSelect: handleOnSelect,
    onSelectAll: handleOnSelectAll,
  };
  function getTitle() {
    if (props.group) {
      return `Assign Alerts: ${props.group.name}`;
    }
    return `Assign Alerts: `;
  }
  return (
    <Backend title={getTitle()}>
      <div className="content-inner">
        <ReactSelect
          containerStyle={{ width: '30%' }}
          isClearable={false}
          label="Department"
          options={props.departments}
          value={dept.id}
          onChange={({ value }) => setDept({ id: value })}
          valueKey="id"
          labelKey="name"
        />
        <Datagrid
          datagridProps={{
            keyField: 'id',
            data: props.remoteDevices,
            columns,
            loading: props.isFetching,
            defaultSorted,
            selectRow,
          }}
          noExport
        />
        <Button
          id="assign-alerts-btn"
          classes="mt-20"
          loading={props.isSubmitting}
          onClick={() => props.onAssignAlerts(selected)}
        >
          <i className="md-icon">done</i>
          {t('Assign')}
        </Button>
      </div>
    </Backend>
  );
};

export default withTranslation('app')(AssignAlertsPage);
